module.exports = __webpack_public_path__ + "img/606b9f7b-f5b3-4591-8e12-486efed88afe.55df63a7.jpg";